module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_04_stay-9f133740c665da2463f88a3b46c11a42.jpg";